import {FC, useCallback, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../_metronic/helpers'
import WSButton from '../../../../../_metronic/helpers/components/WSButton/WSButton'
import {useCreateSubClientTokensMutation} from '../../../../../services/cellcast.v2'
import {toast} from 'react-toastify'

export type CreateTokenProps = {
  userId: string
  show: boolean
  handleClose: () => void
  callbackFn: () => void
}

const CreateToken: FC<CreateTokenProps> = (props) => {
  const {userId, show, handleClose, callbackFn} = props
  const [name, setName] = useState('')
  const [createToken, {isLoading}] = useCreateSubClientTokensMutation()

  const handleCreate = useCallback(() => {
    if (name === '') {
      return
    }

    createToken({
      id: userId,
      data: {name},
    })
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)

          if (callbackFn) {
            callbackFn()
          }
        } else if ('error' in res) {
          const errObj = res.error as any
          if (errObj.data.message) {
            toast.error(errObj.data.message)
          } else {
            toast.error(res.error)
          }
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
  }, [show, userId, name])

  return (
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-700px h-auto'
      show={show}
      onHide={handleClose}
    >
      <div className='scroll-x'>
        <div className='modal-header'>
          <h2 className='fs-2'>Create API Key</h2>
          <div className='btn btn-icon btn-sm' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body py-lg-5 px-lg-5 border-bottom'>
          <div className='mb-10 container'>
            <label className='form-label required'>API Name</label>
            <input
              onChange={(e: any) => setName(e.target.value)}
              type='text'
              className='form-control form-control-solid bg-light border-0'
              placeholder='Your API Name'
            />
          </div>

          <div className='container d-flex align-items-end justify-content-end mt-6 mb-5'>
            <WSButton
              type='submit'
              className='btn btn-lg btn-light-primary me-5 fw-500'
              onClick={handleClose}
            >
              <span className='indicator-label'>Cancel</span>
            </WSButton>
            <WSButton
              disabled={name?.trim() === '' || isLoading}
              type='submit'
              className='btn btn-lg btn-primary fw-500'
              onClick={() => handleCreate()}
            >
              <span className='indicator-label'>{isLoading ? 'Processing' : 'Submit'}</span>
            </WSButton>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default CreateToken
